import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as S from './style';
import { message } from 'antd';
import styled from 'styled-components';
import { IconChevronDown } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import CoinList from './CoinList';

interface MenuListProps {
  menu: any;
}

const TransArrow = styled(IconChevronDown)
  .withConfig({
    shouldForwardProp: (prop) => prop !== 'isHover',
  })
  .attrs<{ isHover?: boolean }>(({ isHover, ...rest }) => ({
    ...rest,
    style: {
      transform: isHover ? 'rotate(180deg)' : 'none',
    },
  }))`
    transition: all 0.2s ease-in-out;
`;

export default function MenuList({ menu }: MenuListProps) {
  const [isHover, setIsHover] = useState(false);
  const { t } = useTranslation();

  const handleMouseEnter = () => setIsHover(true);
  const handleMouseLeave = () => setTimeout(() => setIsHover(false), 50);

  return (
    <S.MenuLi onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <S.Menu onClick={handleMouseLeave} to={menu.link}>
        {menu.title}{' '}
        {menu.dropdown && <TransArrow size={14} isHover={isHover} />}
      </S.Menu>
      {menu.dropdown && (
        <S.SubMenuWrap className={isHover ? 'hover' : ''}>
          <S.SubMenu>
            {menu?.subMenu.map((item: any, index: number) => {
              if (item.title === t('usdtPerpetuals')) {
                return <CoinList handleMouseLeave={handleMouseLeave} />;
              } else {
                return (
                  <S.SubMenuList
                    key={index}
                    className={item.inactive ? 'inactive' : ''}
                  >
                    <Link
                      onClick={() => {
                        handleMouseLeave();
                        if (item.inactive) {
                          message.warning('This feature is not available yet');
                          return;
                        }
                      }}
                      to={item.inactive ? '#' : item.link}
                    >
                      <h4>{item.title}</h4>
                      <p>{item.description}</p>
                    </Link>
                  </S.SubMenuList>
                );
              }
            })}
          </S.SubMenu>
        </S.SubMenuWrap>
      )}
    </S.MenuLi>
  );
}
